import { BaseEntityModel } from '../core/abstractions/base-entity.model';

export class LocationModel extends BaseEntityModel {
    countryId: string;
    zipCode: string;
    city: string;
    canton: string;

    constructor(init: Partial<LocationModel>) {
        super();
        Object.assign(this, init);
    }
}
